import React, { Component } from 'react';
import cookie from 'react-cookies';
import { Button, Paragraph, Link } from 'components';
import './CookieInfo.scss';

class CookieInfo extends Component {
  static COOKIES_ACCEPTED_COOKIE = 'cookies-accepted';

  constructor(props) {
    super(props);

    this.state = {
      areCookiesAccepted:
        cookie.load(this.constructor.COOKIES_ACCEPTED_COOKIE) === 'true',
    };
  }

  handleCookiesAccept = () => {
    this.setState({ areCookiesAccepted: true });
    cookie.save(this.constructor.COOKIES_ACCEPTED_COOKIE, true, { path: '/' });
  };

  render() {
    const { areCookiesAccepted } = this.state;

    return areCookiesAccepted ? null : (
      <div className={'cookie-info'}>
        <div className={'cookie-info__container'}>
          <Paragraph
            color={'white'}
            additionalClass={'cookie-info__description text--light'}
          >
            We use cookies. By continuing to browse the site you are agreeing
            to&nbsp;
            <Link to={'/privacy-policy/'}>our privacy policy</Link>.
          </Paragraph>
          <Button
            color={'white'}
            onClick={() => this.handleCookiesAccept()}
            additionalClass={'cookie-info__button'}
            transparent
          >
            Ok, I agree
          </Button>
        </div>
      </div>
    );
  }
}

export default CookieInfo;
